document.addEventListener("DOMContentLoaded", function () {
  const dropdownItems = document.querySelectorAll(".has-dropdown");

  dropdownItems.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const dropdown = this.querySelector(".dropdown");
      dropdown.classList.toggle("show");
    });
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function (event) {
    dropdownItems.forEach((item) => {
      if (!item.contains(event.target)) {
        const dropdown = item.querySelector(".dropdown");
        dropdown.classList.remove("show");
      }
    });
  });
});
